import { jsx } from "react/jsx-runtime";
import React from "react";
import { DionEnvServiceWrapper } from "@dion-web/env-service";
const DionWebContainerBrowserAppLazy = React.lazy(() => import("../DionWebContainerBrowserApp"));
const DionWebContainerApp = (props) => {
  return /* @__PURE__ */ jsx(
    DionEnvServiceWrapper,
    {
      lazyChildrenProps: props,
      lazyChildren: DionWebContainerBrowserAppLazy,
      url: "/platform/envs.json"
    }
  );
};
export {
  DionWebContainerApp
};
